(function () {
  const STORAGE_KEY = 'text-scale';
  const MIN_SCALE = 0.85;
  const MAX_SCALE = 1.4;
  const STEP = 0.1;
  const DEFAULT = 1;

  const root = document.documentElement;

  function applyScale(scale) {
    const clamped = Math.min(MAX_SCALE, Math.max(MIN_SCALE, scale));
    root.style.setProperty('--font-scale', clamped);
    try {
      localStorage.setItem(STORAGE_KEY, String(clamped));
    } catch (e) {
      // localStorage blocked — fail silently
    }
    announceChange(clamped);
  }

  function getScale() {
    try {
      const stored = parseFloat(localStorage.getItem(STORAGE_KEY));
      return isNaN(stored) ? DEFAULT : stored;
    } catch (e) {
      return DEFAULT;
    }
  }

  function announceChange(scale) {
    let region = document.getElementById('text-resize-live');
    if (!region) {
      region = document.createElement('div');
      region.id = 'text-resize-live';
      region.setAttribute('aria-live', 'polite');
      region.setAttribute('role', 'status');
      region.className = 'visually-hidden';
      document.body.appendChild(region);
    }
    const percent = Math.round(scale * 100);
    region.textContent = `Text size ${percent}%`;
  }

  // Restore on load
  applyScale(getScale());

  // Wire buttons
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-resize]');
    if (!btn) return;

    const current = getScale();
    const action = btn.dataset.resize;

    if (action === 'increase') applyScale(current + STEP);
    else if (action === 'decrease') applyScale(current - STEP);
    else if (action === 'reset') applyScale(DEFAULT);
  });
})();